import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconViewSuperEllipse as Icon } from '@alfa-bank/site-icon-view/super-ellipse';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';

import { Logo as Component } from './component';
import type { IDepsMobile, TLogoMobile } from './models';

export const LogoMobile = createWidget<IDepsMobile, TLogoMobile>({
    Icon,
    Text,
})(Component);
